import React, { useContext, useEffect, useState } from "react";

import { EXAM_DOCUMENTS_ENABLED } from "../../../constants/examDocuments";
import { StudentInfoContext } from "./StudentInfoContext";
import { useProfileAlert } from "./useProfileAlert";
import { fetchStudentPracticalExams } from "./studentPracticalExams";
import { ReservationCardUI } from "../../UI";
import { examResultTone } from "./examResultTone";
import ProfileListMeta from "./ProfileListMeta";


export default function StudentPracticalExamsTab() {
   const {
      studentId,
      handleDownloadBorderou,
      downloadingDocumentId,
      downloadError,
   } = useContext(StudentInfoContext);
   const [exams, setExams] = useState([]);
   const [loading, setLoading] = useState(false);
   const [error, setError] = useState("");

   useEffect(() => {
      let stop = false;
      if (!studentId) {
         setExams([]);
         return undefined;
      }

      (async () => {
         setLoading(true);
         setError("");
         try {
            const rows = await fetchStudentPracticalExams(studentId);
            if (!stop) setExams(rows);
         } catch (e) {
            if (!stop) {
               setExams([]);
               setError(e?.message || "Nu am putut încărca examenele practice.");
            }
         } finally {
            if (!stop) setLoading(false);
         }
      })();

      return () => {
         stop = true;
      };
   }, [studentId]);

   useProfileAlert(error);
   useProfileAlert(downloadError ? `Descărcare: ${downloadError}` : "");

   return (
      <div className="studentsProfileUI__attempts">
         {loading && <p>Se încarcă examenele practice…</p>}

         {!loading && !error && exams.length === 0 && (
            <p className="students-info__empty">Nu există examene practice.</p>
         )}

         {!loading && !error && exams.length > 0 && (
            // examenele practice, casete lipite ca rezervările; borderoul se descarcă din colț
            <>
            <ProfileListMeta count={exams.length} one="examen" many="examene" />
            <ReservationCardUI.List>
               {exams.map((exam) => {
                  const meta = [exam.sector, exam.gearbox, exam.instructorName].filter(Boolean).join(" · ");
                  const anyBusy = Boolean(downloadingDocumentId);
                  const busy = Boolean(exam.id) && downloadingDocumentId === exam.id;
                  return (
                     <ReservationCardUI
                        key={exam.key}
                        tone={examResultTone(exam.status)}
                        date={exam.dateLabel}
                        time={exam.timeLabel}
                        // fără sector / cutie / instructor rândul lipsește (nu „—”)
                        lines={[meta || null, exam.statusLabel]}
                        action={
                           EXAM_DOCUMENTS_ENABLED && exam.id
                              ? {
                                   icon: "download",
                                   label: "Descarcă borderoul acestui examen practic",
                                   busy,
                                   disabled: anyBusy,
                                   onClick: () => handleDownloadBorderou?.(exam.id),
                                }
                              : null
                        }
                     />
                  );
               })}
            </ReservationCardUI.List>
            </>
         )}
      </div>
   );
}
